<script lang="ts" setup>import { ref as _ref } from 'vue';

import { faBuildingColumns, faCreditCard } from '@fortawesome/pro-light-svg-icons'
import newPaypalLogoIcon from '@consumer/assets/icons/new/paypal-logo.svg?svgicon'
import RedemptionOptionButton from './RedemptionOptionButton.vue'

let isBankOptionActive = _ref(false)

defineExpose({
  toggleBankOption: (value: boolean) => {
    isBankOptionActive.value = value
  },
})
</script>

<template>
  <div class="w-full flex flex-col lg:flex-row gap-2 pt-15 lg:pt-0">
    <RedemptionOptionButton
      ref="optionButtonPerfectGiftRef"
      :icon="faCreditCard"
      title="Physical Card"
      data-sardine-id="redemption-option-physical-card"
    />
    <RedemptionOptionButton
      ref="optionButtonAchRef"
      :icon="faBuildingColumns"
      title="Bank Account"
      :active="isBankOptionActive"
      data-sardine-id="redemption-option-bank-account"
    />
    <RedemptionOptionButton
      ref="optionButtonPayPalRef"
      :icon="newPaypalLogoIcon"
      title="PayPal"
      data-sardine-id="redemption-option-paypal"
    />
  </div>
</template>
